/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";

import { getData, uploadSingleFile, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import { reactSelectStyle } from "Config/Config";
import { getMemberOptions } from "helper/ContactHelper/ContactHelper";

const SavePrescriptionPopup = ({
  selectedPrescriptionId,
  setSelectedPrescriptionId,
  afterActionClose,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const userObj = {
    label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
    value: userInfo._id,
  };

  // Form state
  const [documentName, setDocumentName] = useState("");
  const [docFileUploading, setDocFileUploading] = useState(false);
  const [fileUploadId, setFileUploadId] = useState(null);
  const [uploadedFile, setUploadedFile] = useState({});
  const [provider, setProvider] = useState("");
  const [testDate, setTestDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [resultDate, setResultDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [referredBy, setReferredBy] = useState("");
  const [comments, setComments] = useState("");
  const [assignTo, setAssignTo] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const [errors, setErrors] = useState({});

  const formRef = useRef(null);

  // Validation
  const validateForm = () => {
    const newErrors = {};
    if (!documentName.trim())
      newErrors.documentName = "Document Name is required.";
    if (!provider.trim()) newErrors.provider = "Provider is required.";
    if (!testDate) newErrors.testDate = "Test Date is required.";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0 && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return Object.keys(newErrors).length === 0;
  };

  // Async load options
  const loadAssineeOptions = async (inputValue) => {
    try {
      const response = await getMemberOptions(inputValue);

      return response;
    } catch (error) {
      // Return current user as fallback if API call fails
      return [];
    }
  };

  //function for file upload
  const uploadHandler = async (files) => {
    try {
      setDocFileUploading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD + `?token=${token}`;
      const response = await uploadSingleFile(requestUrl, files[0]);
      setDocFileUploading(false);
      if (response.status) {
        setFileUploadId(response.data._id);
        setUploadedFile(response.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = () => {
    setFileUploadId(null);
    setUploadedFile({});
  };

  //function for get prescription details
  const getPrescriptionDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MEDICAL_DOCUMENT_BY_ID + // Assuming medical document is used for prescriptions
        `/${selectedPrescriptionId}?token=${token}`;

      console.log("requestUrl", requestUrl);

      const response = await getData(requestUrl);

      console.log("response", response);

      if (response.status) {
        const prescriptionData = response.data;

        setDocumentName(prescriptionData.name);
        setProvider(prescriptionData.provider);
        setTestDate(
          prescriptionData.testdate
            ? new Date(prescriptionData.testdate).toISOString().split("T")[0]
            : ""
        );
        setResultDate(
          prescriptionData.resultdate
            ? new Date(prescriptionData.resultdate).toISOString().split("T")[0]
            : ""
        );
        setReferredBy(prescriptionData.referredby);
        setComments(prescriptionData.comments);
        if (prescriptionData.assignedtovalue) {
          setAssignTo({
            value: prescriptionData.assignedtovalue,
            label: prescriptionData.assignedtolabel,
          });
        }

        setUploadedFile(prescriptionData.uploadedfileobject);
        setFileUploadId(prescriptionData.uploadedfileobject._id);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for save prescription
  const savePrescriptionHandler = async () => {
    // Run validation before saving
    if (!validateForm()) {
      return;
    }
    try {
      setIsSaving(true);
      const apiData = {
        name: documentName,
        provider: provider,
        testdate: testDate,
        resultdate: resultDate,
        referredby: referredBy,
        comments: comments,
        assignto: assignTo ? assignTo?.value : null,
        uploadid: fileUploadId,
      };

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (selectedPrescriptionId) {
        requestUrl +=
          url.API_UPDATE_MEDICAL_DOCUMENT +
          `/${selectedPrescriptionId}?token=${token}`; // Assuming medical document is used for prescriptions

        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_ADD_MEDICAL_DOCUMENT + `?token=${token}`; // Assuming medical document is used for prescriptions

        response = await postData(requestUrl, apiData);
      }

      setIsSaving(false);

      console.log("response", response);

      if (response.status) {
        //close offcanvas
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#savePrescriptionOffCanvas")
        ).hide();
        resetHandler();
        afterActionClose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for reset
  const resetHandler = () => {
    setDocumentName("");
    setFileUploadId(null);
    setUploadedFile({});
    setProvider("");
    setTestDate(new Date().toISOString().split("T")[0]);
    setResultDate(new Date().toISOString().split("T")[0]);
    setReferredBy("");
    setComments("");
    setAssignTo(null);
    setErrors({});
    setSelectedPrescriptionId(null);
  };

  useEffect(() => {
    if (selectedPrescriptionId) {
      getPrescriptionDetails();
    }
  }, [selectedPrescriptionId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="savePrescriptionOffCanvas"
      aria-labelledby="savePrescriptionOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              description
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              Save Prescription
            </h3>
            <p className="text-white fs-sm mb-0">
              Add or update prescription details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            ref={formRef}
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column"
          >
            <div className="fields-container flex-fill">
              {/* Document Name */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="documentName"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  Document Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="documentName"
                  className={`form-control fs-sm shadow-none ${
                    errors.documentName
                      ? "is-invalid"
                      : "border border-gray-300"
                  }`}
                  placeholder="e.g., Blood Test Report"
                  value={documentName}
                  onChange={(e) => {
                    setDocumentName(e.target.value);
                    if (errors.documentName)
                      setErrors((prev) => ({ ...prev, documentName: "" }));
                  }}
                  aria-describedby="documentNameFeedback"
                />
                {errors.documentName && (
                  <div id="documentNameFeedback" className="invalid-feedback">
                    {errors.documentName}
                  </div>
                )}
              </div>

              {/* Attachments */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                  Attachments
                </label>

                <FileUploadField
                  label={t("Upload Documents")}
                  accept="doc mp4 pdf"
                  onUpload={uploadHandler}
                  files={
                    uploadedFile.path
                      ? [
                          {
                            path: url.SERVER_URL + uploadedFile.path,
                            name: uploadedFile.name,
                          },
                        ]
                      : []
                  }
                  onRemove={closeDocFileHandler}
                  loading={docFileUploading}
                  multiple={false}
                  fileType="document"
                />
              </div>

              {/* Provider */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="provider"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  Provider <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="provider"
                  className={`form-control fs-sm shadow-none ${
                    errors.provider ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder="e.g., Dr. Smith"
                  value={provider}
                  onChange={(e) => {
                    setProvider(e.target.value);
                    if (errors.provider)
                      setErrors((prev) => ({ ...prev, provider: "" }));
                  }}
                  aria-describedby="providerFeedback"
                />
                {errors.provider && (
                  <div id="providerFeedback" className="invalid-feedback">
                    {errors.provider}
                  </div>
                )}
              </div>

              {/* Test Date */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="testDate"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  Test Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  id="testDate"
                  className={`form-control fs-sm shadow-none ${
                    errors.testDate ? "is-invalid" : "border border-gray-300"
                  }`}
                  value={testDate}
                  onChange={(e) => {
                    setTestDate(e.target.value);
                    if (errors.testDate)
                      setErrors((prev) => ({ ...prev, testDate: "" }));
                  }}
                  aria-describedby="testDateFeedback"
                />
                {errors.testDate && (
                  <div id="testDateFeedback" className="invalid-feedback">
                    {errors.testDate}
                  </div>
                )}
              </div>

              {/* Result Date */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="resultDate"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  Result Date
                </label>
                <input
                  type="date"
                  id="resultDate"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  value={resultDate}
                  onChange={(e) => setResultDate(e.target.value)}
                />
              </div>

              {/* Referred By */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="referredBy"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  Referred By
                </label>
                <input
                  type="text"
                  id="referredBy"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="e.g., Dr. John"
                  value={referredBy}
                  onChange={(e) => setReferredBy(e.target.value)}
                />
              </div>

              {/* Comments */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="comments"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  Comments
                </label>
                <textarea
                  id="comments"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  rows={3}
                  placeholder="Additional notes..."
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </div>

              {/* Assign To */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="assignTo"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  Assign To
                </label>
                <AsyncSelect
                  id="assignTo"
                  loadOptions={loadAssineeOptions}
                  defaultOptions={[userObj]}
                  value={assignTo}
                  onChange={(option) => {
                    setAssignTo(option);
                    if (errors.assignTo)
                      setErrors((prev) => ({ ...prev, assignTo: "" }));
                  }}
                  isClearable
                  placeholder="Search or select user..."
                  styles={reactSelectStyle("3px", "6px", true, false)}
                />
              </div>
            </div>
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                onClick={savePrescriptionHandler}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>
                    Save Prescription
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SavePrescriptionPopup;
